import { observer } from 'mobx-react';
import InvitationsLink from './InvitationsLink';
import InviteTimeHeader from './InviteTimeHeader';

interface Props {
  children: React.ReactNode;
}

function InviteTimeForm({ children }: Props) {
  return (
    <>
      <InviteTimeHeader />
      {children}
      <InvitationsLink />
    </>
  );
}

export default observer(InviteTimeForm);
